import React from 'react';
import FontAwesome from 'react-fontawesome';
import { Content, Box } from 'reactjs-admin-lte';
import { Button } from 'react-bootstrap';
import Pagination from 'components/core/Pagination';
import GlossaryListFilter from './GlossaryListFilter';
import GlossaryListTable from './GlossaryListTable';

const GlossaryList = (props) => {

  const {
    glossaries,
    keyword,
    category,
    categoryOptions,
    pageSize,
    selected,
    currentPage,
    isLoading,
    handleSelect,
    handleTabOpen,
    handleSubmit,
    handleDelete,
    handlePageSelect,
    handleKeywordChange,
    handleCategoryChange,
    showAddModal
  } = props;

  return (
    <Content.Body>
      <GlossaryListFilter
        keyword={keyword}
        category={category}
        options={categoryOptions}
        handleSubmit={handleSubmit}
        handleKeywordChange={handleKeywordChange}
        handleCategoryChange={handleCategoryChange} />
      <div className="clearfix">
        <Button
          bsStyle="danger"
          bsSize="sm"
          type="button"
          className="mb-10 pull-right"
          disabled={selected.length === 0}
          onClick={handleDelete}>
          <FontAwesome name="times-circle" className="mr-5" />Delete
        </Button>
      </div>
      <Box
        className="box-widget mb-0"
        loading={isLoading}>
        <Box.Body noPadding={true}>
          <GlossaryListTable
            glossaries={glossaries}
            handleSelect={handleSelect}
            handleTabOpen={handleTabOpen} />
        </Box.Body>
        <Box.Footer>
          <Button
            type="button"
            bsStyle="primary"
            onClick={showAddModal}>
            <FontAwesome name="plus" className="mr-5" />Add New Glossary
          </Button>
          <Pagination
            currentPage={currentPage}
            totalPages={pageSize}
            onChange={handlePageSelect} />
        </Box.Footer>
      </Box>
    </Content.Body>
  )
}

export default GlossaryList;